import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('as-vertical-layout')
export class VerticalLayout extends LitElement {
  static styles = css`
    .vertical-layout {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }
  `;

  render() {
    return html`
      <div class="vertical-layout">
        <slot></slot>
      </div>
    `;
  }
}
